import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'

/**
 * Displays the licence counter of a sensor.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmCounter = (classes, props = {}) => {
  const { counter = '-' } = props

  return (
    <Text
      color={'black'}
      variant={'14/medium'}
      className={classes.row}
    >
      {counter}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmCounter)
